module.exports = __webpack_public_path__ + "static/media/34-5.573ee7b7.mp3";